import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutPageComponent } from './pages/layout.page/layout.page.component';
import { Page404PageComponent } from './pages/page404.page/page404.page.component';

// components prime
import { SelectButtonModule } from 'primeng/selectbutton';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';

/**
 *  Call shared module
 */

import { SharedModule } from '../shared/sharedComponents/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { UnauthorizedPageComponent } from './pages/unauthorized.page/unauthorized.page.component';
import { ForbiddenPageComponent } from './pages/forbidden.page/forbidden.page.component';
import { LayoutPageAndMapComponent } from './pages/layout-page-and-map/layout-page-and-map.component';
import { DesignSystemModule } from '../shared/sharedModules/designSystem/design-system.module';
import { LayoutPageAndMapService } from './pages/layout-page-and-map/layout-page-and-map.service';
import { PermissionMenuService } from '../shared/sharedModules/permission/permission-menu.service';
import { UnavailableComponent } from './pages/unavailable/unavailable.component';
import { HttpClient } from '@angular/common/http';
import { MuContextSettings } from '../shared/types/contextSettings.type';
import { LayoutAuthComponent } from './pages/layout-auth/layout-auth.component';
import { UserDataService } from '../shared/sharedServices/user-data.service';
import { LayoutMainComponent } from './pages/layout-main/layout-main.component';
import { SharedAuthModule } from '../shared/sharedModules/auth/shared-auth.module';
import { TopbarMenuComponent } from './pages/layout.page/components/topbar-menu/topbar-menu.component';
import { LayoutPageMenuSidebarComponent } from './pages/layout.page/components/menu-sidebar/layout-page-menu-sidebar.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { LayoutPageMenuTopBarComponent } from './pages/layout.page/components/menu-top-bar/layout-page-menu-top-bar.component';

@NgModule({
  declarations: [
    LayoutPageComponent,
    Page404PageComponent,
    UnauthorizedPageComponent,
    ForbiddenPageComponent,
    LayoutPageAndMapComponent,
    UnavailableComponent,
    LayoutAuthComponent,
    LayoutMainComponent,
    TopbarMenuComponent,
    LayoutPageMenuSidebarComponent,
    LayoutPageMenuTopBarComponent,
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: MuContextSettings.language(''),
        deps: [HttpClient],
      },
      isolate: true,
    }),
    CommonModule,
    LayoutRoutingModule,
    FormsModule,
    SelectButtonModule,
    MenuModule,
    MenubarModule,
    SharedModule,
    ToastModule,
    ButtonModule,
    DesignSystemModule,
    TabViewModule,
    SharedAuthModule,
    PanelMenuModule,
  ],
  providers: [MessageService, LayoutPageAndMapService, PermissionMenuService, UserDataService],
})
export class LayoutModule {}
